import { useGameStore } from '@/store/gameStore'
import { isFeatureUnlocked, CLUB_LEVELS } from '@/config/clubLevelConfig'
import { Lock } from 'lucide-react'

interface FeatureGateProps {
  feature: string
  children: React.ReactNode
  inline?: boolean // render inline lock instead of replacing content
}

/** Wraps content that requires a specific feature to be unlocked */
export function FeatureGate({ feature, children, inline }: FeatureGateProps) {
  const clubLevel = useGameStore(s => s.clubLevel)

  if (isFeatureUnlocked(feature, clubLevel)) {
    return <>{children}</>
  }

  // Find which level unlocks this feature
  const unlockLevel = CLUB_LEVELS.find(l => l.unlocks.includes(feature))
  const levelName = unlockLevel ? `Nv.${unlockLevel.level}: ${unlockLevel.name}` : 'Nivel superior'

  if (inline) {
    return (
      <span className="chip-angled" style={{ gap: '0.3rem' }}>
        <Lock size={10} /> {levelName}
      </span>
    )
  }

  return (
    <div className="feature-gate tx-net">
      <span className="feature-gate-lock">
        <Lock size={26} />
      </span>
      <div className="feature-gate-title">Sección bloqueada</div>
      <div className="feature-gate-sub">
        Sigue haciendo crecer el club para desbloquearla
      </div>
      <span className="chip-angled tone-gold">{levelName}</span>
    </div>
  )
}

/** Hook to check if a feature is unlocked */
export function useFeatureUnlocked(feature: string): boolean {
  const clubLevel = useGameStore(s => s.clubLevel)
  return isFeatureUnlocked(feature, clubLevel)
}
